export default "__VITE_ASSET__BTeTxdA4__"